import React, { useState } from 'react'; 
import { ChevronDown } from 'lucide-react'; 

const FAQComponent = () => { 
    const [activeIndex, setActiveIndex] = useState(null); 

    const faqData = [
      {
        id: 1,
        title: "What is the eligibility criteria for FINXL Business School?",
        content:
          "BE/ B.TECH/ M.TECH, B SC/ M.SC Students CAT/MAT/XAT/MH-CET/CET/CMAT, Aspirants & Coaching Classes, Consultant, Counsellors, B.COM/ M.COM Students, BBA/ BCA/ MCA Students CA Students, BA/ MA",
      },
      {
        id: 2,
        title: "What are the programs offered by FINXL Business School?",
        content:
          " FINXL Business School offers specialized MBA programs in Finance and Fintech, designed to provide practical industry-oriented knowledge.",
      },
      {
        id: 3,
        title: "What is the application process of FINXL Business School?",
        content:
          "The application process involves:Visiting www.fbsedu.in and clicking on 'Apply Now', Creating an account by providing basic details, Filling out and submitting the application form, Attending the Group Discussion (GD), Personal Interview (PI), and FBS's internal aptitude test, Upon selection, completing the admission process,  ",
      },
      {
        id: 4,
        title: "What is the cost of application form of FINXL Business School?",
        content: " The application form fee is Rs. 1,000.",
      },
      {
        id: 5,
        title: "What is the admission procedure for MBA? How to apply?",
        content:
          "Submit an online application with required details.  Appear for FBS's internal test or provide a valid entrance exam score. -> Attend GD and PI rounds. -> If selected, pay the registration fee (Rs. 50,000) and complete enrollment. ",
      },
      {
        id: 6,
        title: "Which entrance score is accepted by FINXL Business School?",
        content:
          "FINXL accepts scores from FBS’s internal test : GMAT™, CAT, NMAT, CMAT, MAT, MH MBA CET, XAT ",
      },
      {
        id: 7,
        title: "What is the pattern of the entrance test of FBS?",
        content:
          " The FBS entrance test is a 2-hour test with 50 multiple-choice questions from: Basic Accounting & Finance (10 questions), Verbal Ability (10 questions),Reading Comprehension (10 questions),Quantitative Aptitude (10 questions),Data Adequacy & Interpretation (10 questions),No negative marking.",
      },
      {
        id: 8,
        title: "What is the fees structure of FINXL Business School?",
        content:
          "The total fee for the program is Rs. 6,50,000 without hostel and Rs. 7,70,000 with hostel. This includes a registration fee of Rs. 50,000, tuition fees of Rs. 3,00,000 per year for two years, and hostel plus food charges of Rs. 1,20,000 for the first year (applicable only for students opting for hostel).",
      },
      {
        id: 9,
        title: "Does the college provide EMI options for fees payments?",
        content:
          "Yes, EMI options are available through financial institutions. ",
      },
      {
        id: 10,
        title: "What are the scholarships offered by FINXL Business School?",
        content:
          " FINXL offers scholarships to outstanding candidates who demonstrate value-based leadership and contribute to business diversity. Contact the admission team for details.",
      },
      {
        id: 11,
        title: "What is the ROI at FINXL Business School?",
        content:
          "Graduates of FINXL Business School have secured competitive compensation packages, reflecting the program’s focus on industry-relevant skills and practical learning.",
      },

      {
        id: 12,
        title: "What extra curricular activities are available at the college?",
        content:
          " Students can participate in: Music (Instrumental & Vocal), Dance, Sports (Cricket, Volleyball, Table Tennis, Badminton, etc.), Student Clubs & Committees",
      },
      {
        id: 13,
        title: "What are the top companies visiting for placements?",
        content:
          "FINXL has a strong placement network with top recruiters from finance, consulting, and fintech industries. Visit the placement section for details. ",
      },
      {
        id: 14,
        title: "Do FINXL MBA programs include internship job opportunities?",
        content:
          "Yes, students receive internships from top companies, providing real-world business experience.",
      },
      {
        id: 15,
        title: "Are placements guaranteed to FBS students?",
        content:
          "FINXL offers placement assistance to FBS students, subject to the following conditions: 90% attendance, 80% score in assessments, timely assignment submissions, and active participation in mock interviews and soft-skill training.",
      },
      {
        id: 16,
        title: "Is Hostel Accommodation available for the students?",
        content:
          "Yes, but only for 30 students on campus., Monthly living costs (off-campus): Rs. 10,000 - 15,000,Assistance is provided for finding nearby accommodation. ",
      },
      {
        id: 17,
        title: "In case of queries on MBA program whom do I contact?",
        content:
          " You can reach out via - Email: info@finxl.in Phone: +91-96 61 62 63 71,+91-96 61 62 63 80, +91 77 22 01 31 42, +91-81 09 13 09 09, +91 81 09 24 09 09, For more details, visit: www.fbsedu.in",
      },
    ]; 

    const toggleAccordion = (index) => { 
        setActiveIndex(activeIndex === index ? null : index); 
    }; 

    return ( 
        <div className="min-h-screen flex bg-white"> 
            <div className="container mx-auto p-10 flex flex-col items-center"> 
                <div className="text-center mb-8"> 
                    <div className="w-96 max-w-full bg-orange-500 h-0.5 mx-auto mb-3"></div> 
                    <p className="text-orange-500 font-semibold text-xl">Frequently Asked Questions</p> 
                </div> 

                <div className="accordion w-full lg:flex lg:flex-col lg:max-w-2xl lg:m-auto"> {/* Centering questions on large screens */} 
                    {faqData.map((item) => ( 
                        <div key={item.id} className="border-b border-gray-200"> 
                            <button className={`relative w-full text-left py-4 pr-6 text-gray-600 hover:text-cyan-500 focus:text-cyan-500 text-lg font-normal focus:outline-none ${activeIndex === item.id ? 'text-cyan-500 border-b border-cyan-500' : ''}`} onClick={() => toggleAccordion(item.id)} aria-expanded={activeIndex === item.id}> 
                                <span className="pr-6">{item.title}</span> 
                                <span className={`absolute right-0 top-5 w-6 h-6 border rounded-full border-current flex items-center justify-center ${activeIndex === item.id ? 'text-cyan-500' : ''}`}> 
                                    <ChevronDown className={`w-4 h-4 relative transition-transform duration-200 ${activeIndex === item.id ? 'transform rotate-180' : ''}`} /> 
                                </span> 
                            </button> 

                            <div className={`overflow-hidden transition-all duration-200 ${activeIndex === item.id ? 'max-h-56 opacity-100' : 'max-h-0 opacity-0'}`}> 
                                <p className="py-6 text-base font-light">{item.content}</p> 
                            </div> 
                        </div> 
                    ))} 
                </div> 
            </div> 
        </div> 
    ); 
}; 

export default FAQComponent;
